import { ID, Currency } from './common';
import { Cliente } from './cliente';
import { Inmueble } from './inmueble';
import { Garantia } from './garantia';

export const EstadoContrato = {
  BORRADOR: 'BORRADOR',
  ACTIVO: 'ACTIVO',
  FINALIZADO: 'FINALIZADO',
  RESCINDIDO: 'RESCINDIDO',
} as const;
export type EstadoContrato = typeof EstadoContrato[keyof typeof EstadoContrato];

export const TipoContrato = {
  AUTOMATICO: 'AUTOMATICO',
} as const;
export type TipoContrato = typeof TipoContrato[keyof typeof TipoContrato];

export const FormaPago = {
  MES_VENCIDO: 'MES_VENCIDO',
} as const;
export type FormaPago = typeof FormaPago[keyof typeof FormaPago];

export const TipoReajuste = {
  TOTAL: 'TOTAL',
} as const;
export type TipoReajuste = typeof TipoReajuste[keyof typeof TipoReajuste];

export const TipoAlquiler = {
  ASEGURADO: 'ASEGURADO',
  NO_ASEGURADO: 'NO_ASEGURADO',
} as const;
export type TipoAlquiler = typeof TipoAlquiler[keyof typeof TipoAlquiler];

export interface Contrato {
  id: ID;
  correlativo: number;
  numero_contrato: string;
  inmueble_id: ID;
  inquilino_id: ID;
  inquilinos_auxiliares?: string; // Additional tenant names for receipts (e.g., Porto Seguro)
  fecha_inicio: string; // YYYY-MM-DD
  fecha_fin: string; // YYYY-MM-DD
  monto_alquiler_inquilino: number;
  moneda_inquilino: Currency;
  monto_alquiler_propietario: number;
  moneda_propietario: Currency;
  comision: number; // percentage
  no_retiene_irpf?: boolean;
  iva?: number;
  default_iva?: number; // System default IVA from configuracion_sistema
  deposito?: number;
  dia_pago: number;
  tipo_contrato: TipoContrato;
  auto_renovacion: boolean;
  estado: EstadoContrato;
  fecha_reajuste?: string | null;
  forma_pago?: FormaPago;
  tipo_reajuste?: TipoReajuste;
  tipo_alquiler?: TipoAlquiler;
  notas?: string;
  en_lista_juridica?: boolean;
  fecha_ingreso_lista_juridica?: string | null;
  notas_lista_juridica?: string;
  // Payment agreement fields (Meeting 10-02-26)
  en_convenio?: boolean;
  fecha_convenio?: string | null;
  garantia_id?: ID | null;
  garantia?: string;
  garante_nombre?: string | null;
  garantia_detalle?: string | null;
  garantia_nombre?: string;
  garantia_tipo?: 'INSTITUCIONAL' | 'PERSONAL';
  garantia_descripcion?: string | null;
  garantia_es_predefinida?: boolean;
  periodos?: ContratoPeriodo[];
  inquilino_agente_retencion_irpf?: boolean; // Derived from the tenant, read-only
  creado_por?: ID;
  created_at?: string;
  updated_at?: string;
  fecha_ultimo_pago_propietario?: string | null; // YYYY-MM-DD
  fecha_ultimo_pago_inquilino?: string | null; // YYYY-MM-DD
  // Nested objects populated by API
  inquilino?: Cliente;
  inmueble?: Inmueble;
  propietarios?: PropietarioContrato[];
  liquidacion_propietario?: {
    net_amount: number;
    commission: number;
    iva_commission: number;
    irpf: number;
    breakdown: Record<string, number>;
  } | null;
  garantia_obj?: Garantia | null;
  // Computed/joined fields from API
  inquilino_nombre?: string;
  inmueble_direccion?: string;
  inmueble_padron?: string;
}

export interface PropietarioContrato extends Cliente {
  irpf_siempre?: boolean;
  irpf_mensual?: number | null;
  irpf_error?: string | null;
  porcentaje_propiedad?: number;
  no_comision?: boolean;
  no_irpf?: boolean;
  retiene_irpf?: boolean | null;
  residencia?: string;
}

export interface ContratoPeriodo {
  id?: ID;
  contrato_id?: ID;
  fecha_inicio: string;
  fecha_fin: string;
  orden: number;
  es_prorroga: boolean;
}

export interface Descuento {
  id: ID;
  contrato_id: ID;
  descripcion: string;
  monto: number;
  moneda: Currency;
}

